import {Component} from '@angular/core';

@Component({
  selector: 'app-ai-loading-overlay',
  templateUrl: './ai-loading-overlay.component.html',
  styleUrls: ['./ai-loading-overlay.component.scss'],
  standalone: true
})
export class AiLoadingOverlayComponent {}
